import { SectionFrame } from '@/app/pages'
import type { RouteDef } from '@/app/routes'
import { Card, EmptyState } from '@/design'
import { useGlobalFilters } from '@/lib/useGlobalFilters'

import { DailyMetricsPanel } from './DailyMetricsPanel'

/** Analytics landing. The full business overview is a follow-up; daily rollups are real today. */
export function BusinessOverviewPage({ route }: { route: RouteDef }) {
  const { filters } = useGlobalFilters()
  return (
    <SectionFrame route={route}>
      <div className="ci-stack">
        <DailyMetricsPanel environments={filters.environments} />
        <Card>
          <EmptyState
            variant="no-data"
            compact
            title="More business analytics are coming soon"
            description="Trading breakdowns by competition, channel and customer arrive in a follow-up release."
          />
        </Card>
      </div>
    </SectionFrame>
  )
}
